import { CasinoGame } from '../hooks/use-casino-games';

export const TOP_TEN_COUNT = 10;

export const getTrendingGames = (games: CasinoGame[]) =>
    [...games].sort((a, b) => b.popularity - a.popularity).slice(0, TOP_TEN_COUNT);
